import { Row, Col } from 'reactstrap';
import Form, { AddNewContainer } from './form';
import PageLoader from 'common/components/general/PageLoader';
import MenusTree from 'common/components/beacon/components/tree';

import { useEffect } from 'react';
import { useActions } from 'utils/hooks';
import { useSelector } from 'react-redux';
import {
  selectHasMenus,
  selectIsTreeInitialized,
  selectMenuFormIsVisible
} from 'common/components/beacon/store/selectors';
import { setActiveMenuIdAction, toggleMenuFormAction } from 'common/components/beacon/store/slice';
import * as beaconActions from 'common/components/beacon/store/actions';

const Menu = () => {
  const [getBeaconMenus, createBeaconMenu, editBeaconMenu, setActiveMenuId, toggleMenuForm] =
    useActions([
      beaconActions.getBeaconMenus,
      beaconActions.createBeaconMenu,
      beaconActions.editBeaconMenu,
      setActiveMenuIdAction,
      toggleMenuFormAction
    ]);

  const hasMenus = useSelector(selectHasMenus);
  const isInitialized = useSelector(selectIsTreeInitialized);
  const formIsVisible = useSelector(selectMenuFormIsVisible);

  useEffect(() => {
    getBeaconMenus();
  }, [getBeaconMenus]);

  if (!isInitialized) return <PageLoader isLoading />;

  return (
    <Row noGutters>
      <Col xs={3}>
        {hasMenus ? (
          <MenusTree />
        ) : (
          <AddNewContainer formIsVisible={formIsVisible} onClick={() => toggleMenuForm(true)} />
        )}
      </Col>
      <Col xs={6} className="ps-5 ps-hd-10">
        {formIsVisible && (
          <Form
            onCreate={createBeaconMenu}
            onEdit={editBeaconMenu}
            onCancel={() => {
              toggleMenuForm(false);
              setActiveMenuId(null);
            }}
          />
        )}
      </Col>
    </Row>
  );
};

export default Menu;
